import { Text } from '@zillow/constellation-10';

import stringHelper from '../../utils/stringHelper';

import type { LocaleSpecificNoticeProps } from '../../model/LocaleSpecificNotice';

type Props = {
  localeSpecificNotice?: LocaleSpecificNoticeProps;
};

const LocaleNotice = ({ localeSpecificNotice }: Props) => {
  if (!localeSpecificNotice?.text || localeSpecificNotice?.text.trim() === '') {
    return null;
  }

  return (
    <Text data-testid="LocaleNotice" textStyle="body-sm" asChild>
      <em>{stringHelper.renderWithReplacedLinks(localeSpecificNotice)}</em>
    </Text>
  );
};

export default LocaleNotice;
